export default "__VITE_ASSET__wE4N98oP__"